import type { FunctionComponent } from 'react';

import { RouterLink } from '@trello/router/router-link';

import type { EnterpriseEntity } from './types';

interface EnterpriseProps extends Pick<EnterpriseEntity, 'id' | 'text'> {
  isEnterpriseAdmin?: boolean;
}

export const Enterprise: FunctionComponent<EnterpriseProps> = ({
  text,
  id,
  isEnterpriseAdmin = false,
}) => {
  if (isEnterpriseAdmin) {
    const enterpriseUrl = `/e/${id}/admin/teams`;

    return <RouterLink href={enterpriseUrl}>{text}</RouterLink>;
  } else {
    return <span>{text}</span>;
  }
};
